import { Country } from '@/helpers/conf';

export const COOKIE_GEO_COUNTRIES = [
  Country.Australia,
  Country.Germany,
  Country.Austria,
  Country.Switzerland,
] as const;

export type CookieGeoCountry = (typeof COOKIE_GEO_COUNTRIES)[number];

export const getCookieGeoCountry = (
  countryCode: string,
  hasStag: boolean
): CookieGeoCountry | null =>
  hasStag
    ? null
    : (COOKIE_GEO_COUNTRIES.find((country) => country === countryCode) ?? null);
